import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { SocialService } from 'src/app/shared/services/angular-service/social.service';

@Component({
  selector: 'app-feeds-user-post-card',
  templateUrl: './feeds-user-post-card.component.html',
  styleUrls: ['./feeds-user-post-card.component.scss']
})
export class FeedsUserPostCardComponent implements OnInit {
  @Input() userPost;
  likesCount: 0;
  isLiked: boolean = false;
  actionData: any;
  userId;
  onSession: string;

  constructor(private router: Router,
    private socialService: SocialService,
    private cdRef: ChangeDetectorRef,
    private localStorage: LocalStorageService
  ) {
    this.userId = this.localStorage.getItem('userId')
    this.onSession = this.localStorage.getItem('onSession')
  }

  ngOnInit(): void {
    this.getLikeCount();
  }

  getLikeCount() {
    this.socialService
      .getLikeCount(this.userPost._id)
      .then((data: any) => {
        if (data) {
          this.actionData = data
          this.isLiked = this.actionData.likers.includes(this.userId);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  navigateToDetailsPage(feed) {
    this.router.navigate([`/feed/details/${feed._id}`]);
  }

  toggleLike(): void {
    if (this.isLiked) {
      this.unlikePost();
    } else {
      this.likePost();
    }
    this.cdRef.detectChanges();
  }

  likePost() {
    let UpdateDocument = {
      post: this.userPost._id
    }
    this.socialService
      .like(UpdateDocument)
      .then((data: any) => {
        if (data) {
          this.actionData = data;
          this.isLiked = this.actionData.likers.includes(this.userId);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });

  }


  unlikePost() {
    let UpdateDocument = {
      post: this.userPost._id
    }
    this.socialService
      .unlike(UpdateDocument)
      .then((data: any) => {
        if (data) {
          this.actionData = data;
          this.isLiked = this.actionData.likers.includes(this.userId);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });

  }

}
